/* eslint-disable no-unused-vars */
import { Field, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import { ModalUpdateVehiclePR } from '../../../utils/validationSchema'
import TextField from '../../Input/TextInput'
import { capitalizeWords } from '../../../helpers/constants'
import UploadFile from '../../molecules/UploadFile'
import PreviewImage from '../../molecules/PreviewImage'

const title = {
  fontSize: '9px',
  lineHeight: '12px',
  color: '#828282'
}

const ModalUpdateVehiclePrDraft = (props) => {
  const {
    updateVehicleInList,
    selectedVehicle,
    refreshdata,
    isPacking = false,
    setFieldValue = undefined,
    dataValues = undefined
  } = props
  const [file, setFile] = useState(false)
  const [fileSimImg, setFileSimImg] = useState(null)
  const [simTempPath, setSimTempPath] = useState(null)
  const [fileStnk, setFileStnk] = useState(false)
  const [fileStnkImg, setFileStnkImg] = useState(null)
  const [stnkTempPath, setStnkTempPath] = useState(null)
  const [uploadingSimDoc, setUploadingSimDoc] = useState(false)
  const [uploadingStnkDoc, setUploadingStnkDoc] = useState(false)
  const maxSize = 1242880 // max size file upload
  const typeImage = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf']

  useEffect(() => {
    if (props.show === false) {
      setFile(false)
      setSimTempPath(null)
      setStnkTempPath(null)
    }
    if (selectedVehicle) {
      setFileSimImg(selectedVehicle?.sim_doc)
      setFileStnkImg(selectedVehicle?.stnk_doc)
      setSimTempPath(selectedVehicle?.sim_doc_temp_path || null)
      setStnkTempPath(selectedVehicle?.stnk_doc_temp_path || null)
    }
  }, [props.show, selectedVehicle])

  const uploadFileToTemp = async (fileObj) => {
    let fileData = fileObj
    if (typeof fileObj === 'string' && fileObj.startsWith('data:')) {
      const response = await fetch(fileObj)
      const blob = await response.blob()
      fileData = new File([blob], `camera-${Date.now()}.jpg`, {
        type: 'image/jpeg'
      })
    }

    const formData = new FormData()
    formData.append('file', fileData)
    formData.append('module', 'inbound')

    const res = await api.post('/upload/temp-file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })

    return res.data.data.tempPath
  }

  const filehandleFileSim = async (e) => {
    let fileObj = null
    let fileName = ''

    if (e.target) {
      const size = e.target.files[0].size
      const typeFile = e.target.files[0].type

      if (size > maxSize) {
        Common.showPopUpErrorMessage('Cant upload file more than 5 MB')
        return
      } else if (!typeImage.includes(typeFile)) {
        Common.showPopUpErrorMessage('File upload must jpg/jpeg/png or pdf')
        return
      }
      fileObj = e.target.files[0]
      fileName = fileObj.name
    } else {
      fileObj = e
      fileName = typeof e === 'string' ? e : 'camera-capture.jpg'
    }

    setUploadingSimDoc(true)
    try {
      const tempPath = await uploadFileToTemp(fileObj)
      setFile(fileName)
      setFileSimImg(fileObj)
      setSimTempPath(tempPath)
    } catch (err) {
      Common.showPopUpErrorMessage('Failed to upload SIM document')
    } finally {
      setUploadingSimDoc(false)
    }
  }

  const filehandleFileStnk = async (e) => {
    let fileObj = null
    let fileName = ''

    if (e.target) {
      const size = e.target.files[0].size
      const typeFile = e.target.files[0].type

      if (size > maxSize) {
        Common.showPopUpErrorMessage('Cant upload file more than 5 MB')
        return
      } else if (!typeImage.includes(typeFile)) {
        Common.showPopUpErrorMessage('File upload must jpg/jpeg/png or pdf')
        return
      }
      fileObj = e.target.files[0]
      fileName = fileObj.name
    } else {
      fileObj = e
      fileName = typeof e === 'string' ? e : 'camera-capture.jpg'
    }

    setUploadingStnkDoc(true)
    try {
      const tempPath = await uploadFileToTemp(fileObj)
      setFileStnk(fileName)
      setFileStnkImg(fileObj)
      setStnkTempPath(tempPath)
    } catch (err) {
      Common.showPopUpErrorMessage('Failed to upload STNK document')
    } finally {
      setUploadingStnkDoc(false)
    }
  }

  const handleSubmit = async (values) => {
    if (updateVehicleInList === undefined) {
      const data = {
        ...values,
        sim_doc_temp_path: simTempPath,
        stnk_doc_temp_path: stnkTempPath
      }
      const res = await api.post(
        `inbound/pr-draft/vehicle/${selectedVehicle.id}`,
        data
      )
      if (res.status === 200) {
        props.onHide()
        Common.showPopUpSuccessMessage(res.data.message)
        refreshdata()
      }
    } else {
      const vehicleData = {
        ...values,
        sim_doc: fileSimImg,
        stnk_doc: fileStnkImg,
        sim_doc_temp_path: simTempPath,
        stnk_doc_temp_path: stnkTempPath
      }
      if (!isPacking) {
        updateVehicleInList(vehicleData)
      } else {
        updateVehicleInList(setFieldValue, vehicleData, dataValues)
      }
      props.onHide()
    }
  }

  return (
    <Modal {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Vehicle Info</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            id: selectedVehicle?.id || '',
            plate_no: selectedVehicle?.plate_no || '',
            sim_validity: selectedVehicle?.sim_validity,
            sim_notes: selectedVehicle?.sim_notes || '',
            sim_doc: selectedVehicle?.sim_doc || '',
            stnk_notes: selectedVehicle?.stnk_notes || '',
            stnk_validity: selectedVehicle?.stnk_validity,
            stnk_doc: selectedVehicle?.stnk_doc || ''
          }}
          enableReinitialize={true}
          validationSchema={ModalUpdateVehiclePR}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={(values, { resetForm }) => {
            handleSubmit(values)
            resetForm()
          }}
        >
          {({
            handleBlur,
            handleSubmit,
            values,
            isValid,
            dirty,
            touched,
            setFieldValue,
            errors
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={12}>
                    <Form.Label className="fw-bold">
                      <h4>{selectedVehicle?.plate_no || ''}</h4>
                    </Form.Label>
                  </Col>
                  {/* SIM */}
                  <>
                    <Col md={12} className="mt-3">
                      <Form.Label className="fw-normal">
                        <h6>SIM</h6>
                      </Form.Label>
                    </Col>
                    <Col md={12}>
                      <Row>
                        <Col md={6}>
                          {uploadingSimDoc && (
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                width: '100px',
                                height: '100px',
                                border: '2px solid #dee2e6',
                                borderRadius: '10px'
                              }}
                            >
                              <Spinner animation="border" size="sm" />
                            </div>
                          )}
                          {!uploadingSimDoc && !fileSimImg && (
                            <UploadFile
                              handleFileChange={(e) => {
                                filehandleFileSim(e)
                                setFieldValue(
                                  'sim_doc',
                                  e.target?.files[0]?.name || e
                                )
                              }}
                            />
                          )}
                          {!uploadingSimDoc && fileSimImg && (
                            <PreviewImage
                              value={fileSimImg}
                              handleDelete={() => {
                                setFile(false)
                                setFileSimImg(null)
                                setSimTempPath(null)
                                setFieldValue('sim_doc', '')
                              }}
                            />
                          )}
                        </Col>
                        <Col md={6} style={{ marginTop: '-2rem' }}>
                          <Row>
                            <Col md={12}>
                              <Form.Label className="fw-bold">
                                <small style={title}>
                                  VALIDITY <sup style={{ color: 'red' }}>*</sup>
                                </small>
                              </Form.Label>
                            </Col>
                            <Col>
                              <Row>
                                <Col
                                  onChange={() => {
                                    setFieldValue('sim_validity', true)
                                  }}
                                >
                                  <Field
                                    type="radio"
                                    name="sim_validity"
                                    value={true}
                                    checked={values?.sim_validity === true}
                                    id="sim_validity_valid"
                                  />
                                  <label
                                    className="ms-2"
                                    htmlFor="sim_validity_valid"
                                  >
                                    Valid
                                  </label>
                                </Col>
                                <Col
                                  onChange={() => {
                                    setFieldValue('sim_validity', false)
                                  }}
                                >
                                  <Field
                                    type="radio"
                                    name="sim_validity"
                                    value={false}
                                    checked={values?.sim_validity === false}
                                    id="sim_validity_invalid"
                                  />
                                  <label
                                    className="ms-2"
                                    htmlFor="sim_validity_invalid"
                                  >
                                    Invalid
                                  </label>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={12} className="mt-3">
                      <TextField
                        label="notes"
                        name="sim_notes"
                        value={values.sim_notes}
                        handleChange={(e) => {
                          if (e.target.value.length > 50) return
                          const capitalizedValue = capitalizeWords(
                            e.target.value
                          )
                          setFieldValue('sim_notes', capitalizedValue)
                        }}
                        handleBlur={handleBlur}
                        placeholder="Keterangan"
                        touched={touched}
                        errors={errors}
                      />
                    </Col>
                  </>
                  {/* STNK */}
                  <>
                    <Col md={12} className="mt-4">
                      <Form.Label className="fw-normal">
                        <h6>STNK</h6>
                      </Form.Label>
                    </Col>
                    <Col md={12}>
                      <Row>
                        <Col md={12}>
                          <Row>
                            <Col md={6}>
                              {uploadingStnkDoc && (
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{
                                    width: '100px',
                                    height: '100px',
                                    border: '2px solid #dee2e6',
                                    borderRadius: '10px'
                                  }}
                                >
                                  <Spinner animation="border" size="sm" />
                                </div>
                              )}
                              {!uploadingStnkDoc && !fileStnkImg && (
                                <UploadFile
                                  handleFileChange={(e) => {
                                    filehandleFileStnk(e)
                                    setFieldValue(
                                      'stnk_doc',
                                      e.target?.files[0]?.name || e
                                    )
                                  }}
                                />
                              )}
                              {!uploadingStnkDoc && fileStnkImg && (
                                <PreviewImage
                                  value={fileStnkImg}
                                  handleDelete={() => {
                                    setFileStnk(false)
                                    setFileStnkImg(null)
                                    setStnkTempPath(null)
                                    setFieldValue('stnk_doc', '')
                                  }}
                                />
                              )}
                            </Col>
                            <Col md={6} style={{ marginTop: '-2rem' }}>
                              <Row>
                                <Col md={12}>
                                  <Form.Label className="fw-bold">
                                    <small style={title}>
                                      VALIDITY{' '}
                                      <sup style={{ color: 'red' }}>*</sup>
                                    </small>
                                  </Form.Label>
                                </Col>
                                <Col md={12}>
                                  <Row>
                                    <Col
                                      onChange={() => {
                                        setFieldValue('stnk_validity', true)
                                      }}
                                    >
                                      <Field
                                        type="radio"
                                        name="stnk_validity"
                                        value={true}
                                        checked={values.stnk_validity === true}
                                        id="stnk_validity_valid"
                                      />
                                      <label
                                        className="ms-2"
                                        htmlFor="stnk_validity_valid"
                                      >
                                        Valid
                                      </label>
                                    </Col>
                                    <Col
                                      onChange={() => {
                                        setFieldValue('stnk_validity', false)
                                      }}
                                    >
                                      <Field
                                        type="radio"
                                        name="stnk_validity"
                                        value={false}
                                        checked={values.stnk_validity === false}
                                        id="stnk_validity_invalid"
                                      />
                                      <label
                                        className="ms-2"
                                        htmlFor="stnk_validity_invalid"
                                      >
                                        Invalid
                                      </label>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={12} className="mt-3">
                      <TextField
                        label="notes"
                        name="stnk_notes"
                        value={values.stnk_notes}
                        handleChange={(e) => {
                          if (e.target.value.length > 50) return
                          const capitalizedValue = capitalizeWords(
                            e.target.value
                          )
                          setFieldValue('stnk_notes', capitalizedValue)
                        }}
                        handleBlur={handleBlur}
                        placeholder="Keterangan"
                        touched={touched}
                        errors={errors}
                      />
                    </Col>
                  </>
                </Row>
                <Modal.Footer className="mt-3">
                  <Button
                    type="submit"
                    variant={!isValid || !dirty ? 'secondary' : 'warning'}
                    className="text-white"
                    disabled={
                      !isValid || !dirty || uploadingSimDoc || uploadingStnkDoc
                    }
                  >
                    {uploadingSimDoc || uploadingStnkDoc
                      ? 'Uploading...'
                      : 'Update'}
                  </Button>
                </Modal.Footer>
              </Form>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default ModalUpdateVehiclePrDraft
